export default {
    name: "clientList",
    data:function(){
        return{
            searchString:'',
            searchResult:'尚无客户',
            init:false,
            ListCustomerInfo:[],
            showSearchResult:false
        }
    },
    methods:{
        search:function (fn) {
            var _this=this;
            this.$post("/customerservicemanager/mycustomer",{
                Search:this.searchString
            },function (result) {
                if(result.Success){
                    _this.init=true;
                    _this.ListCustomerInfo=result.Result.ListCustomerInfo;
                    fn&&fn(result);
                }else{
                    _this.$toast(result.Message)
                }
            })
        },
        search2:function () {
            var _this=this;
            if(this.searchString){
                this.search(function () {
                    _this.searchResult="查询（"+_this.searchString+"）的结果";
                    _this.showSearchResult=true;
                })
            }else{
                this.search(function (result) {
                    if(result.Result.ListCustomerInfo.length==0){
                        _this.searchResult="尚无客户";
                        _this.showSearchResult=true;
                    }
                })
            }

        }
    },
    mounted:function () {
        var _this=this;
        this.search(function (result) {
            if(result.Result.ListCustomerInfo.length==0){
                _this.searchResult="尚无客户";
                _this.showSearchResult=true;
            }
        });
    },
    computed:{

    }
}


// WEBPACK FOOTER //
// ./src/ally/page/myClient/clientList.js